import { groupBy, mapValues } from 'lodash-es'
import type { optionType } from './dictionary.ts'
import { slovakRegionsList } from './slovakRegions.ts'

export const helpHow: optionType[] = [
    {
        id: 'free-help',
        value: 'dobrovolnik',
        label: 'Dobrovoľník'
    },
    {
        id: 'member',
        value: 'clen-timu',
        label: 'Člen tímu'
    }
]

export const helpWho: optionType[] = [
    {
        id: 'school',
        value: 'neziskovka',
        label: 'neziskovke, škole'
    },
    {
        id: 'public-institute',
        value: 'institucia',
        label: 'verejnej inštitúcii'
    },
    {
        id: 'startup',
        value: 'startup',
        label: 'startupu'
    },
    {
        id: 'student-project',
        value: 'studentsky projekt',
        label: 'študentskému projektu'
    }
]

export const slovakRegionOptions: optionType[] = slovakRegionsList.map((region) => ({
    id: region,
    value: region,
    label: `${region} kraj`
}))

export const helpWhoFilter: optionType[] = [
    {
        id: 'school',
        value: 'neziskovka',
        label: 'neziskovku, školu'
    },
    {
        id: 'public-institute',
        value: 'institucia',
        label: 'verejnú inštitúciu'
    },
    {
        id: 'startup',
        value: 'startup',
        label: 'startup'
    },
    {
        id: 'student-project',
        value: 'studentsky projekt',
        label: 'študentský projekt'
    }
]

export const helpWhoIdToLabelMap = mapValues(
    groupBy(
        helpWhoFilter.map((item: optionType, idx: number) => {
            return {
                ...item,
                index: idx + 1
            }
        }),
        'id'
    ),
    (value: any) => value[0]
)

export const capacity: optionType[] = [
    {
        id: 'once',
        value: 'jednorazovo',
        label: 'krátkodobo, resp. max 3 konzultácie'
    },
    {
        id: 'long_term',
        value: 'dlhodobo',
        label: 'dlhšiu dobu, aj niekoľko týždňov'
    }
]

export const capacityIdToLabelMap = mapValues(
    groupBy(
        capacity.map((item: optionType, idx: number) => {
            return {
                ...item,
                index: idx + 1
            }
        }),
        'id'
    ),
    (value: any) => value[0]
)

export const cooperationType: optionType[] = [
    {
        id: 'online',
        value: 'online',
        label: 'na diaľku (online)'
    },
    {
        id: 'personal',
        value: 'osobne',
        label: 'osobné stretnutia'
    }
]

// Options for prefersFieldOfExperience field
// Values match VolunteerPrefersFieldOfExperience enum: 'yes', 'no', 'either'
export const volunteerTypeOptions: optionType[] = [
    {
        id: 'no',
        value: 'no',
        label: 'Rukami',
        description: '(manuálne dobrovoľníctvo, napr. chcem sa naučiť niečo iné, chcem si vyvetrať hlavu...)'
    },
    {
        id: 'yes',
        value: 'yes',
        label: 'Hlavou',
        description:
            '(chcem dobrovoľníčiť v oblasti, v ktorej mám profesnú skúsenosť, - práca, podnikanie, dobrovoľníctvo, projekt)'
    },
    {
        id: 'either',
        value: 'either',
        label: 'Som otvorený/á obom možnostiam'
    }
]
